import {FIND_TALENT_APPLICATION, REMIND_TALENT_LATE_REQUEST, UPDATE_APPLICATION_FLOW} from "../action-types";
import {call, put, takeEvery} from 'redux-saga/effects'
import {findTalentApplicationSuccess, remindTalentLateFailure, remindTalentLateSuccess, updateApplicationFlowSuccess} from "../actions/JobOffer";
import {fetchError, fetchExpired, fetchStart, fetchSuccess} from "../actions/Common";
import {findTalentApplicationRequest, remindTalentOfDelay, updateJobApplicationFlowRequest} from "../api/JobOfferApplication";
import { toast } from "react-toastify";

function* handleRemindTalentLate(action) {
    try {
        const { token, id, intl } = action.payload;
        const response = yield call(remindTalentOfDelay, token, id);
        console.log(response,"response");
        

        if (response.status === 200) {
            yield put(remindTalentLateSuccess(response.data.message));
            toast.success(intl.formatMessage({id: "reminder.sent.success"}));
        } else if (response.status === 400) {
            toast.error(intl.formatMessage({id: "reminder.limit.reached"}));
            yield put(remindTalentLateFailure(response.data.message));
        } else if (response.status === 403) {
            toast.error(intl.formatMessage({id: "accessDeniedMessage"}));
            yield put(remindTalentLateFailure(response.data.message));
        } else if (response.status === 500) {
            toast.error(intl.formatMessage({id: "global_error_portage"}));
            yield put(remindTalentLateFailure(response.data.message));
        }
    } catch (error) {
      yield put(remindTalentLateFailure(error?.message));
    }
  }

function* findTalentApplication({token, talentID}){
    try {
        const response = yield call(findTalentApplicationRequest, token, talentID)
        if (response.status === 200) {
            if (response.data.errors && response.data.errors.length > 0) {
                yield put(fetchError(response.data))
            } else {
                yield put(findTalentApplicationSuccess(response.data))
                yield put(fetchSuccess())
            }
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.log(error)
    }
}
function* updateApplicationFlow({token, formData, intl, typeMes}){
    try {
        yield put(fetchStart())
        const response = yield call(updateJobApplicationFlowRequest, token, formData)
        if (response.status === 200) {
            yield put(updateApplicationFlowSuccess(response.data))
            typeMes === "schedule" && toast.success(intl.formatMessage({id: "scheduleSuccess"}))
            typeMes === "rejecte" && toast.success(intl.formatMessage({id: "applicationrejected"}))
            yield put(fetchSuccess())
        }
        if (response.status === 401) {
            yield put(fetchExpired())
            toast.error(intl.formatMessage({ id: "error401" }));
        }
        if (response.status === 403) {
            toast.error(intl.formatMessage({id: "accessDeniedMessage"}))
        }
        if (response.status === 499) {
            yield put(fetchSuccess())
            toast.error(intl.formatMessage({ id: "error.interview.not.done" }));
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
            toast.error(intl.formatMessage({ id: "server_error_portage" }));
        }
    } catch (error) {
        console.log(error)
        toast.error(intl.formatMessage({ id: "global_error_portage" }));

    }
}
export default function* jobOfferApplicationSaga() {
    yield takeEvery(FIND_TALENT_APPLICATION, findTalentApplication)
    yield takeEvery(UPDATE_APPLICATION_FLOW, updateApplicationFlow)
    yield takeEvery(REMIND_TALENT_LATE_REQUEST, handleRemindTalentLate)
}